import { parseDateTime } from '@/core/utils/parsing.ts'
import { Dayjs } from 'dayjs'

interface Props {
  field?: string | Dayjs | null
  inputFormat?: string
  outputFormat?: string
  isoDate?: boolean
}

const DateTime = ({
  field,
  inputFormat = 'DD-MM-YYYY',
  outputFormat,
  isoDate
}: Props) => {
  return (
    field &&
    parseDateTime({
      value: field,
      inFormat: inputFormat,
      outputFormat,
      isoDate
    })
  )
}

export default DateTime
